module.exports = __WEBPACK_EXTERNAL_MODULE__52248__;